import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";

const INTRO = [
  "Answers to the most common questions about funding, getting paid, and staying protected on PAYD.",
];

const SECTIONS = [
  {
    id: "what-is-payd",
    title: "What is PAYD?",
    blocks: [
      { type: "p", text: "PAYD is a milestone-based escrow platform. A payer funds work into an on-chain escrow up front, the payee delivers, and funds are released once the work is approved." },
    ],
  },
  {
    id: "fund-milestone",
    title: "How do I fund a milestone?",
    blocks: [
      { type: "p", text: "Open the contract and click Fund escrow on a milestone. Funding takes two wallet confirmations: first you approve the escrow to use your USDC, then you confirm the deposit. You pay the network gas for both." },
    ],
  },
  {
    id: "get-paid",
    title: "How do I get paid?",
    blocks: [
      { type: "p", text: "Once the payer approves your work, click Claim payment. The funds are released on-chain straight to your connected wallet. The payer never needs to do anything after approving." },
    ],
  },
  {
    id: "where-money",
    title: "Where is my money held?",
    blocks: [
      { type: "p", text: "Funds sit in the escrow smart contract until released, then settle directly to your wallet. PAYD never holds your money; the Earnings page is just a record of what you've been paid." },
    ],
  },
  {
    id: "invoices",
    title: "How do invoices work?",
    blocks: [
      { type: "p", text: "Standalone invoices are paid directly: the payer funds the amount into escrow and the payee claims it. Invoices linked to a milestone are reminders; the payer approves the milestone and payment follows the milestone's claim." },
    ],
  },
  {
    id: "disputes",
    title: "What if there's a disagreement?",
    blocks: [
      { type: "p", text: "Either party can open a dispute on a funded milestone, which pauses release until it's resolved. An admin reviews and resolves it as release, refund, or split, and the relevant party then claims their share." },
    ],
  },
  {
    id: "karma",
    title: "What is Karma?",
    blocks: [
      { type: "p", text: "Karma is your reputation on PAYD. You earn it by paying on time, completing contracts without disputes, and resolving issues fairly. Late approvals or disputes found against you reduce it." },
    ],
  },
  {
    id: "wallet",
    title: "Do I need a crypto wallet?",
    blocks: [
      { type: "p", text: "Yes. Connect and link a wallet in Settings → Payment methods. Funding and claiming happen on-chain, and you'll need a small amount of network gas to send those transactions." },
    ],
  },
  {
    id: "contact",
    title: "Still need help?",
    blocks: [
      { type: "contact", name: "PAYD LLC", address: "282 Mountain Road, Pleasantville, NY, 10570", email: "hello@payd.day" },
    ],
  },
];

const Help = () => (
  <LegalLayout title="Help & FAQs" eyebrow="Help" intro={INTRO} sections={SECTIONS} />
);

export default Help;
